import React from 'react';
import { useTranslation } from 'next-i18next';

import { GradeDescription, GradeWithDescription, Wrapper } from './styles';
import EnergyCertificateGradeA from '@spa/shared/svg/energy-certificate-grade-a';
import EnergyCertificateGradeB from '@spa/shared/svg/energy-certificate-grade-b';
import EnergyCertificateGradeC from '@spa/shared/svg/energy-certificate-grade-c';
import EnergyCertificateGradeD from '@spa/shared/svg/energy-certificate-grade-d';
import EnergyCertificateGradeE from '@spa/shared/svg/energy-certificate-grade-e';
import EnergyCertificateGradeF from '@spa/shared/svg/energy-certificate-grade-f';
import EnergyCertificateGradeG from '@spa/shared/svg/energy-certificate-grade-g';

export const EnergyCertificateGradesList = () => {
  const { t } = useTranslation();

  return (
    <Wrapper>
      <GradeWithDescription>
        <EnergyCertificateGradeA className="grade-a" />
        <GradeDescription>{t('The most efficient')}</GradeDescription>
      </GradeWithDescription>
      <EnergyCertificateGradeB className="grade-b" />
      <EnergyCertificateGradeC className="grade-c" />
      <GradeWithDescription>
        <EnergyCertificateGradeD className="grade-d" />
        <GradeDescription>{t('Medium consumption')}</GradeDescription>
      </GradeWithDescription>
      <EnergyCertificateGradeE className="grade-e" />
      <EnergyCertificateGradeF className="grade-f" />
      <GradeWithDescription>
        <EnergyCertificateGradeG className="grade-g" />
        <GradeDescription>{t('The least efficient')}</GradeDescription>
      </GradeWithDescription>
    </Wrapper>
  );
};
